import { makeStyles } from '@material-ui/core/styles';


export const YourDetailsSideBarCss = makeStyles((theme) => ({

    transactionDetailsDrawer: {
        width: 420,
        maxWidth: 420,
        [theme.breakpoints.down('sm')]: {
            top: '56px!important',
            height: 'calc(100vh - 0px)'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px!important',
            height: 'calc(100vh - 0px)'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    modal: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    backdrop: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        }
    },
    divTitle: {
        display: 'flex',
        alignItems: 'center',
        color: "#0b1323",
        fontSize: 18,
        marginBottom: 4,
        fontWeight: 600,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal'
    },
    dialogTitle: {
        paddingLeft: '30px !important',
        paddingRight: '18px !important',
        paddingTop: '8px !important',
        paddingBottom: '8px !important'
    },
    sideBarDialogContentV1: {
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 32,
        paddingLeft: 30,
        paddingRight: 30,
        paddingBottom: 20,
        backgroundColor: '#f6f6f8'
    },
    dialogActions: {
        paddingTop: '20px !important',
        paddingBottom: '20px !important',
        paddingRight: '30px !important',
        paddingLeft: '30px !important',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    cancelButton: {
        padding: '6px 20px',
        borderRadius: '4px',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        border: 'solid 1px #d8dce6',
        background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        marginRight: 16,
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            background: 'linear-gradient(to top, #f6f7f9, #ffffff)'
        }
    },
    saveButton: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#161f34',
        color: 'white',
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#161f34'
        }
    },
    saveButtonDisabled: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#e2e2e2 !important',
        color: 'rgba(11, 19, 35, 0.6) !important',
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#e2e2e2 !important'
        }
    },
    mtV2: {
        marginTop: 4
    },
    textFieldV1: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            color: '#0b1323'
        }
    },
    syncIcon: {
        color: '#0033cc',
        marginRight: 8
    },
    divAlign: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 8,
        width: 'fit-content',
        cursor: 'pointer'
    },
    textV1: {
        color: '#0033cc',
        fontWeight: 600
    },
    titleV1: {
        fontSize: '14px',
        fontWeight: 600,
        color: 'rgba(11, 19, 35, 0.75)'
    },
    divAlignV1: {
        display: 'flex',
        marginTop: 16
    },
    widthV1: {
        width: '50%',
        marginRight: 16
    },
    widthV2: {
        width: '50%'
    },
    listBoxAutoCompelete: {
        margin: 0,
        padding: 0
    },
    listBoxOption: {
        padding: 0,
        minHeight: 46,
        maxHeight: 46,
        borderBottom: '1px solid #eaedf3',
        "&:first-child": {
        },
        "&:last-child": {
        }
    },
    divV1: {
        display: 'flex',
        width: '100%',
        paddingTop: 5,
        paddingBottom: 5
    },
    divV1Gst: {
        display: 'flex',
        width: '100%',
        // paddingTop: 5,
        // paddingBottom: 5,
        borderBottom: '1px solid #ebebeb',
        alignItems: 'center'
    },
    autoCompleteListbox: {
        padding: '0px !important'
    },
    autoCompleteOption: {
        padding: '0px !important'
    },
    colorV1: {
        color: 'lightgray'
    },
    divV2: {
        width: '100%',
        paddingBottom: 10,
        paddingLeft: 5
    },
    divV2Gst: {
        width: '100%',
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8
    },
    displayEndAdornment: {
        display: 'none'
    },
    autoCompleteInput: {
        backgroundColor: 'white !important',
        paddingRight: '6px !important'
    },
    mtV1: {
        marginTop: 16
    },
    textFieldV2: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            color: '#0b1323'
        },
        "& .MuiOutlinedInput-input": {
            textTransform: 'uppercase'
        }
    },
    eventIcon: {
        color: 'grey',
    },
    selectRoot: {
        backgroundColor: 'transparent !important'
    },
    menuItem: {
        borderBottom: '1px solid #ebebeb'
    },
    divAlignV2: {
        display: 'flex',
        alignItems: 'center'
    },
    autocompleteRootGst: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: 'white !important'
        }
    },
    switchLabel: {
        fontSize: '14px !important'
    }

}));

export const ChargesDeductionsSideBarCss = makeStyles((theme) => ({

    transactionDetailsDrawer: {
        width: 448,
        maxWidth: 448,
        [theme.breakpoints.down('sm')]: {
            top: '56px!important',
            height: 'calc(100vh - 0px)'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px!important',
            height: 'calc(100vh - 0px)'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    modal: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    backdrop: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        }
    },
    dialogTitle: {
        paddingLeft: '30px !important',
        paddingRight: '18px !important',
        paddingTop: '12px !important',
        paddingBottom: '12px !important'
    },
    divTitle: {
        display: 'flex',
        alignItems: 'center',
        color: "#0b1323",
        fontSize: 20,
        marginBottom: 4,
        fontWeight: 600,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal'
    },
    sideBarDialogContentV1: {
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 32,
        paddingLeft: 30,
        paddingRight: 30,
        paddingBottom: 20,
        backgroundColor: '#f6f6f8'
    },
    dialogActions: {
        paddingTop: '20px !important',
        paddingBottom: '20px !important',
        paddingRight: '30px !important',
        paddingLeft: '30px !important',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    cancelButton: {
        padding: '6px 20px',
        borderRadius: '4px',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        border: 'solid 1px #d8dce6',
        background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            background: 'linear-gradient(to top, #f6f7f9, #ffffff)'
        }
    },
    gridContainerV1: {
        padding: '16px',
        borderRadius: '8px',
        border: 'solid 1px #dcdcdc',
        backgroundColor: '#ededed'
    },
    dotV1: {
        color: '#c4c4c4',
        width: 10,
        height: 10,
        marginLeft: 4,
        marginRight: 4
    },
    divAlign: {
        display: 'flex',
        alignItems: 'center'
    },
    mlV1: {
        marginLeft: 4
    },
    gridContainerV2: {
        marginTop: 2,
        fontSize: '12px',
        color: '#0b1323'
    },
    fw600: {
        fontWeight: 600
    },
    gridChargesDeductions: {
        borderRadius: '8px',
        border: 'solid 0.5px rgba(0, 0, 0, 0.25)',
        backgroundColor: '#ffffff',
        marginTop: 12
    },
    editIcon: {
        color: '#0033cc',
        fontSize: 16
    },
    deleteIcon: {
        color: '#ff0000',
        fontSize: 16
    },
    editButton: {
        borderRadius: '4px',
        border: 'solid 1px #0033cc',
        width: 26,
        height: 26
    },
    deleteButton: {
        borderRadius: '4px',
        border: 'solid 1px #ff0000',
        width: 26,
        height: 26
    },
    gridV1: {
        padding: 16
    },
    gridV2: {
        borderLeft: '2px solid rgba(0, 0, 0, 0.05)'
    },
    mlV2: {
        marginLeft: 16
    },
    mlV3: {
        marginLeft: 12
    },
    mtV2: {
        marginTop: 16
    },
    addChargeButton: {
        backgroundColor: '#0033cc',
        color: 'white',
        borderRadius: 4,
        textTransform: 'none',
        fontSize: 16,
        fontWeight: 600,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 10,
        paddingBottom: 10,
        '&:hover': {
            backgroundColor: '#0033cc'
        }
    },
    gridContainerV3: {
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16
    },
    gridDescription: {
        fontSize: '12px',
        fontStyle: 'italic',
        color: 'rgba(11, 19, 35, 0.75)'
    },
    gridV3: {
        paddingRight: 16
    },
    mtV3: {
        marginTop: 12
    },
    textV1: {
        fontSize: 16,
        fontWeight: 600,
        color: '#0b1323'
    },
    textV2: {
        fontSize: 12,
        color: '#0b1323',
        marginTop: 2
    },
    loss: {
        fontSize: 16,
        fontWeight: 600,
        color: '#ff0000',
        marginTop: 2
    },
    gridV4: {
        fontSize: 16
    }

}));

export const InvoiceAddPaymentSideBarCss = makeStyles((theme) => ({

    transactionDetailsDrawer: {
        width: 420,
        maxWidth: 420,
        [theme.breakpoints.down('sm')]: {
            top: '56px!important',
            height: 'calc(100vh - 0px)'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px!important',
            height: 'calc(100vh - 0px)'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    transactionDetailsDrawerChooseTrips: {
        width: 540,
        maxWidth: 540,
        [theme.breakpoints.down('sm')]: {
            top: '56px!important',
            height: 'calc(100vh - 0px)'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px!important',
            height: 'calc(100vh - 0px)'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    modal: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    backdrop: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        }
    },
    divBox: {
        padding: '2px 4px',
        borderRadius: '2px',
        backgroundColor: '#c6d4ff',
        fontSize: '10px',
        color: '#0033cc',
        width: 'fit-content',
        letterSpacing: '0.05em',
        fontWeight: 'bold'
    },
    cancelButton: {
        padding: '6px 20px',
        borderRadius: '4px',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        border: 'solid 1px #d8dce6',
        background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        fontWeight: 300,
        textTransform: 'none',
        marginRight: 16,
        '&:hover': {
            background: 'linear-gradient(to top, #f6f7f9, #ffffff)'
        }
    },
    chooseTripsButton: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#161f34',
        color: 'white',
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#161f34'
        }
    },
    chooseTripsButtonDisabled: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#e2e2e2 !important',
        color: 'rgba(11, 19, 35, 0.6) !important',
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#e2e2e2 !important'
        }
    },
    dialogActions: {
        paddingTop: 20,
        paddingBottom: '20px !important',
        paddingLeft: 30,
        paddingRight: 30,
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'normal'
    },
    divAlignActions: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    divTitle: {
        fontSize: 20,
        fontWeight: 600,
        color: '#0b1323'
    },
    formTitle: {
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: 'rgba(11, 19, 35, 0.75)'
    },
    mtV2: {
        marginTop: 4
    },
    textFieldV1: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            color: '#0b1323'
        }
    },
    mtV3: {
        marginTop: 16
    },
    textFieldV2: {
        backgroundColor: 'white'
    },
    eventIcon: {
        color: 'grey',
    },
    mlV2: {
        marginLeft: 4
    },
    divAlignV2: {
        display: 'flex'
    },
    divAlignV1: {
        display: 'flex',
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: '#e8843c'
    },
    divAlign: {
        display: 'flex',
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: '#0033cc'
    },
    marginV1: {
        marginLeft: 6,
        marginRight: 6
    },
    gridItemStatus: {
        marginTop: 4,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end'
    },
    divBoxPart: {
        padding: '2px 4px',
        borderRadius: '2px',
        backgroundColor: '#ffdbc1',
        fontSize: '10px',
        color: '#e8843c',
        width: 'fit-content',
        letterSpacing: '0.05em',
        fontWeight: 'bold'
    },
    mlV1: {
        marginLeft: 24
    },
    containerWidth: {
        width: 'fit-content'
    },
    containerWidthV1: {
        width: '180px'
    },
    gridRoute: {
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#0b1323',
        overflowWrap: 'break-word'
    },
    gridParam: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 4,
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: 'rgba(11, 19, 35, 0.75)',
    },
    dotV1: {
        fontSize: 6,
        color: '#c4c4c4',
        marginLeft: 8,
        marginRight: 8
    },
    tripBalance: {
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#0b1323'
    },
    cardInput: {
        backgroundColor: 'white',
        marginLeft: '0.5em',
        width: 86,
        '& .MuiOutlinedInput-input': {
            paddingTop: 1,
            paddingBottom: 1,
            paddingRight: '3px !important'
        }
    },
    sideBarDialogContentV1: {
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 32,
        paddingLeft: 30,
        paddingRight: 30,
        paddingBottom: 20,
        backgroundColor: '#f6f6f8'
    },
    gridContainer: {
        padding: '16px 24px',
        borderRadius: '8px',
        border: 'solid 1px #dcdcdc',
        backgroundColor: '#ededed'
    },
    titleV1: {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: 1.5,
        color: 'rgba(11, 19, 35, 0.5)'
    },
    textV1: {
        fontSize: '16px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#0b1323',
        marginTop: 4
    },
    titleV2: {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: 1.5,
        textAlign: 'right',
        color: 'rgba(11, 19, 35, 0.5)'
    },
    textV2: {
        fontSize: '16px',
        fontWeight: 300,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#0b1323',
        marginTop: 4
    },
    mtV1: {
        marginTop: 30
    },
    dialogV1: {
        borderRadius: '8px !important'
    },
    widthV1: {
        maxWidth: '420px !important'
    },
    divAlignTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
    },
    divTitle: {
        fontSize: 20,
        fontWeight: 300
    },
    closeIconV1: {
        color: '#D0D0D0',
        fontSize: 20
    },
    dialogContentV1: {
        paddingTop: 24,
        paddingBottom: '24px !important',
        paddingLeft: 30,
        paddingRight: 30,
        backgroundColor: '#f6f6f8'
    },
    gridTitleDialog: {
        fontSize: '12px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: 'rgba(11, 19, 35, 0.75)',
        paddingLeft: 8,
        paddingRight: 8,
        marginBottom: 8
    },
    gridParamsDialog: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 2,
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#0b1323',
    },
    dotV2: {
        fontSize: '6px !important',
        color: '#c4c4c4',
        marginLeft: 4,
        marginRight: 6
    },
    textBalance: {
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#0b1323'
    },
    saveButton: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#09101e',
        fontSize: '14px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.71,
        letterSpacing: 'normal',
        color: '#ffffff',
        textTransform: 'none',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        marginLeft: '16px !important',
        '&:hover': {
            backgroundColor: '#09101e'
        }
    },
    saveButtonDisabled: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#dadada',
        fontSize: '14px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.71,
        letterSpacing: 'normal',
        color: '#5e636c',
        textTransform: 'none',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        marginLeft: '16px !important',
        '&:hover': {
            backgroundColor: '#dadada'
        }
    },
    divAmountContainer: {
        marginTop: 24
    },
    titleV3: {
        fontSize: '14px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.43,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: 'rgba(11, 19, 35, 0.75)'
    },
    mtV4: {
        marginTop: 4
    },
    mtV5: {
        marginTop: 24
    },
    errorV1: {
        fontSize: 16,
        color: '#ff1744',
        marginBottom: 8
    },
    checkBoxLabel: {
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: 'rgba(11, 19, 35, 0.75)',
        marginBottom: 8
    },
    checkboxInput: {
        width: '100%'
    },
    checkboxTripLabel: {
        height: '100%',
        minHeight: 78,
        maxHeight: 100,
        backgroundColor: 'white',
        borderRadius: 8,
        marginLeft: 0,
        marginRight: 0,
        width: '100%',
        paddingTop: 16,
        paddingBottom: 16,
        paddingRight: 16,
        paddingLeft: 15,
        marginBottom: '12px',
        '& .MuiFormControlLabel-label': {
            width: '100%'
        }
    },
    checkBoxLabel: {
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: 'rgba(11, 19, 35, 0.75)',
        marginBottom: 8
    },
    checkBoxChecked: {
        color: 'transparent !important'
    },
    gridRouteDialog: {
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: '#0b1323'
    },
    closeButton: {
        borderRadius: '4px !important',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        border: 'solid 1px #d8dce6',
        background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 6,
        paddingBottom: 6,
        fontSize: '14px',
        fontWeight: 300,
        lineHeight: 1.43,
        letterSpacing: 'normal',
        color: '#3e3f42',
        textTransform: 'none',
        '&:hover': {
            background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        }
    },
    dialogActionsV1: {
        paddingTop: 20,
        paddingBottom: '20px !important',
        paddingRight: 30,
        paddingLeft: 30
    },
    dialogTitleV1: {
        paddingLeft: 30,
        paddingTop: 8,
        paddingBottom: '8px !important',
        paddingRight: 12
    },
    divAlignTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
    },
    divTitle: {
        fontSize: 20,
        fontWeight: 600
    },
    gridContainerDialog: {
        padding: '16px !important',
        borderRadius: '8px',
        border: 'solid 1px #dcdcdc',
        backgroundColor: '#ededed'
    },
    paymentFullyAllocated: {
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        backgroundColor: '#d6f3e2',
        borderRadius: 8,
        display: 'flex',
        alignItems: 'center',
        marginBottom: 16
    },
    paymentPartiallyAllocated: {
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        backgroundColor: '#ffdbc1',
        borderRadius: 8,
        display: 'flex',
        alignItems: 'center',
        marginBottom: 16
    },
    doneV1: {
        color: '#00875a',
        fontSize: 24
    },
    errorV2: {
        color: '#e86825',
        fontSize: 24
    },
    divAlignV5: {
        marginLeft: 14,
        display: 'flex',
        alignItems: 'center'
    },
    fw300: {
        fontWeight: 300
    },
}));

export const selectBankSideBarCss = makeStyles((theme) => ({

    transactionDetailsDrawer: {
        width: 604,
        maxWidth: 604,
        [theme.breakpoints.down('sm')]: {
            top: '56px!important',
            height: 'calc(100vh - 0px)'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px!important',
            height: 'calc(100vh - 0px)'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    modal: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    backdrop: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        }
    },
    dialogTitle: {
        paddingLeft: '30px !important',
        paddingRight: '18px !important',
        paddingTop: '8px !important',
        paddingBottom: '8px !important'
    },
    divTitle: {
        fontSize: 20,
        fontWeight: 600,
        color: '#0b1323'
    },
    sideBarDialogContentV1: {
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 32,
        paddingLeft: 30,
        paddingRight: 30,
        paddingBottom: 20,
        backgroundColor: '#f6f6f8'
    },
    dialogActions: {
        paddingTop: '20px !important',
        paddingBottom: '20px !important',
        paddingRight: '30px !important',
        paddingLeft: '30px !important',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    cancelButton: {
        padding: '6px 20px',
        borderRadius: '4px',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        border: 'solid 1px #d8dce6',
        background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        fontWeight: 300,
        textTransform: 'none',
        marginRight: 16,
        '&:hover': {
            background: 'linear-gradient(to top, #f6f7f9, #ffffff)'
        }
    },
    saveButton: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#09101e',
        fontSize: '14px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.71,
        letterSpacing: 'normal',
        color: '#ffffff',
        textTransform: 'none',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        marginLeft: '16px !important',
        '&:hover': {
            backgroundColor: '#09101e'
        }
    },
    saveButtonDisabled: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#dadada',
        fontSize: '14px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.71,
        letterSpacing: 'normal',
        color: '#5e636c',
        textTransform: 'none',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        marginLeft: '16px !important',
        '&:hover': {
            backgroundColor: '#dadada'
        }
    },
    selectionDiv: {
        marginBottom: 12,
        marginLeft: 0,
        marginRight: 0,
        padding: 16,
        paddingLeft: '0px !important',
        borderRadius: 8,
        border: "solid 0.5px rgba(0, 0, 0, 0.25)",
        backgroundColor: "#ffffff",
        "& .MuiFormControlLabel-label": {
            width: "100%"
        },
        "& .MuiRadio-colorSecondary.Mui-checked": {
            color: '#0033cc'
        }
    },
    addBankDetailsButton: {
        marginTop: 16,
        padding: "12px 16px",
        borderRadius: 4,
        border: "solid 1px #0033cc",
        backgroundColor: "#fff",
        fontSize: 16,
        fontWeight: 600,
        color: "#0033cc",
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: "#fff",
        }
    },
    info: {
        display: "flex",
        justifyContent: 'space-between',
        marginBottom: 4,
        "&:last-child": {
            marginBottom: 0
        }
    },
    infoV1: {
        display: "flex",
        width: '100%',
        "&:last-child": {
            marginBottom: 0
        }
    },
    primary: {
        fontSize: 14,
        fontWeight: 600,
        textTransform: 'capitalize',
        marginRight: 8,
    },
    verifiedAccount: {
        fontSize: 12,
        color: "rgba(21, 128, 38, 0.6)"
    },
    unVerifiedAccount: {
        fontSize: 12,
        color: "#e93333"
    },
    divAlign: {
        display: 'flex'
    },
    iconV1: {
        fontSize: 22,
        marginTop: -6
    },
    secondary: {
        textTransform: 'capitalize',
        fontSize: 14,
        width: '48%'
    },
    widthV2: {
        width: '50%'
    },
    widthV1: {
        minWidth: 152
    },
    radioPadding: {
        padding: '16px !important',
    },
    fw600: {
        fontWeight: 600
    },
    paddingStart: {
        paddingLeft: 4
    }

}));

export const TransactionDetailsSideBarCss = makeStyles((theme) => ({

    transactionDetailsDrawer: {
        width: 475,
        maxWidth: 475,
        [theme.breakpoints.down('sm')]: {
            top: '56px!important',
            height: 'calc(100vh - 0px)'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px!important',
            height: 'calc(100vh - 0px)'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    modal: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    backdrop: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        }
    },
    dialogTitle: {
        paddingLeft: '30px !important',
        paddingRight: '18px !important',
        paddingTop: '8px !important',
        paddingBottom: '8px !important',
        '& .MuiTypography-root': {
            width: '100%'
        }
    },
    divTitle: {
        display: 'flex',
        alignItems: 'center',
        color: "#0b1323",
        fontSize: 18,
        marginBottom: 4,
        fontWeight: 600,
        letterSpacing: 'normal'
    },
    divAlign: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
    },
    deleteIcon: {
        color: '#ff0000',
        fontSize: 16
    },
    sideBarDialogContentV1: {
        padding: '30px !important',
        backgroundColor: '#f6f6f8'
    },
    titleV1: {
        fontSize: 12,
        color: 'rgba(11, 19, 35, 0.75)',
        textAlign: 'left'
    },
    titleV2: {
        fontSize: 12,
        color: 'rgba(11, 19, 35, 0.75)',
        textAlign: 'left'
    },
    mtV1: {
        marginTop: 16
    },
    cancelButton: {
        padding: '6px 20px',
        borderRadius: '4px',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        border: 'solid 1px #d8dce6',
        background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        marginRight: 16,
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            background: 'linear-gradient(to top, #f6f7f9, #ffffff)'
        }
    },
    divAlignV1: {
        display: 'flex',
        fontSize: 12,
        color: 'rgba(11, 19, 35, 0.75)'
    },
    mlV1: {
        marginLeft: 4
    },
    hrV1: {
        borderTop: '1px dashed #C8C8C8',
        marginTop: 24
    },
    divTripDetails: {
        marginTop: 24
    },
    divAlignV2: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    tripDetailsText: {
        fontSize: '12px',
        fontWeight: 'bold',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: 'rgba(11, 19, 35, 0.75)'
    },
    cardV2: {
        borderRadius: '8px !important',
        marginTop: 8,
        padding: '16px !important',
        paddingBottom: '16px !important',
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
    },
    cardV3: {
        borderRadius: '8px !important',
        marginTop: 12,
        backgroundColor: 'white',
        padding: '16px !important',
        paddingBottom: '16px !important',
        display: 'flex',
        flexDirection: 'column',
    },
    textV3: {
        fontSize: 16,
        fontWeight: 600,
        color: '#0b1323'
    },
    gridV1: {
        textAlign: 'left'
    },
    amountV1: {
        fontSize: 16,
        fontWeight: 600,
        textAlign: 'right',
        color: '#0b1323'
    },
    mtV2: {
        marginTop: 2
    },
    dotV1: {
        color: '#c4c4c4',
        fontSize: 8,
        marginLeft: 6,
        marginRight: 6
    },
    textV1: {
        fontSize: '16px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#0b1323',
        marginTop: 4
    },
    textV2: {
        fontSize: '16px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#0b1323',
        marginTop: 4
    },
    textV7: {
        fontSize: '16px',
        fontWeight: 600,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#0b1323',
        marginTop: 4
    },
    textV6: {
        fontSize: '16px',
        fontWeight: 600,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#0b1323',
        marginTop: 4
    },
    cardV1: {
        borderRadius: '8px !important',
        width: '100%',
        boxShadow: 'none !important'
    },
    listV1: {
        boxShadow: 'none !important'
    },
    textV4: {
        fontSize: 12,
        color: 'rgba(11, 19, 35, 0.75)'
    },
    deleteButton: {
        borderRadius: 4,
        padding: 9,
        border: '1px solid #ff0000',
        marginRight: 20
    }

}));
